module.exports = __webpack_public_path__ + "static/media/capstone_permissions.d1668131.yaml";